import classNames from 'classnames';
import React, { useState } from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap';
import { useContextInfo } from '../../context/ContextInfo';
import { fetchConToken } from '../../api/fetch';

const Confirmation = ({ show, toggle, info, callBk, data = {} }) => {
    const { setResp } = useContextInfo();
    const [send, setSend] = useState(false);
    const { id=0, type="" } = info;

    const delet = async () => {
        if (send) return;
        setSend(true);
        const res = await fetchConToken(`main/${type}/${id}`, data, 'DELETE');
        setResp(res);
        setSend(false);
        callBk();
        toggle();
    };

    return (
        <Modal show={show} onHide={toggle} size="sm">
            <div className={classNames('modal-filled', 'bg-danger')}>
                <Modal.Body className="p-4">
                    <div className="text-center">
                        <i className="dripicons-checkmark h1"></i>
                        <h4 className="mt-2">Eliminar {info.type}</h4>
                        <p className="mt-3">Está seguro que desea eliminar el/la {info.type} seleccionado?</p>
                        {send ? (
                            <Button color="secondary" disabled>
                                <Spinner className="spinner-border-sm me-1" tag="span" color="white" />
                                Enviando...
                            </Button>
                        ) : (
                            <button
                                onClick={delet}
                                type="button"
                                className="btn btn-light my-2"
                                data-bs-dismiss="modal">
                                Si,Eliminar
                            </button>
                        )}
                    </div>
                </Modal.Body>
            </div>
        </Modal>
    );
};
export default Confirmation;
